import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["color", "highlights", "selected", "size", "viewBox", "title", "children"];
import { memo } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const borderRatio = 0.09;
const getWrapperStyle = ({
  color,
  highlights,
  size
}) => {
  const bSize = highlights ? Math.ceil(borderRatio * size) : 0;
  return `
    border-color: ${color};
    border-width: ${bSize}px;
    padding: ${bSize}px;
  `;
};
const Wrapper = styled.span.withConfig({
  displayName: "CsatButton__Wrapper"
})(["cursor:pointer;display:inline-block;border-radius:50%;border-style:solid;", " transition:border-color linear 0.2s;&:not(:hover):not(.selected){border-color:transparent;}"], getWrapperStyle);
const StyledSvg = styled.svg.withConfig({
  displayName: "CsatButton__StyledSvg"
})(["display:block;"]);
const CsatButton = /*#__PURE__*/memo(_ref => {
  let {
      color,
      highlights = true,
      selected = false,
      size,
      viewBox = '0 0 54 54',
      title,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const svgSize = highlights ? size - size * borderRatio * 2 : size;
  return /*#__PURE__*/_jsx(Wrapper, Object.assign({
    className: selected ? "selected" : "",
    color: color,
    highlights: highlights,
    size: size
  }, rest, {
    role: "button",
    children: /*#__PURE__*/_jsxs(StyledSvg, {
      xmlns: "http://www.w3.org/2000/svg",
      width: svgSize,
      height: svgSize,
      viewBox: viewBox,
      children: [/*#__PURE__*/_jsx("title", {
        children: title
      }), /*#__PURE__*/_jsx("g", {
        id: "Connecting-Feedback-CSAT-survey-to-chat",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        children: children
      })]
    })
  }));
});
CsatButton.displayName = 'CsatButton';
export default CsatButton;